import type { IEquity } from '~/api/interface'
import { getOrderUpgradePrice } from '~/api/module/order'

export function useUpgradePackage() {
  const rights = ref<IEquity[]>([])
  const pending = ref<boolean>()

  onMounted(async () => {
    pending.value = true
    try {
      const res = await getOrderUpgradePrice()
      if (res.data) {
        rights.value = res.data
      }
    } catch (err) {
      console.error(err)
    }
    pending.value = false
  })

  return {
    rights,
  }
}
